// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"21e9ccb7","442":"289d3d2d"}[chunkId] + ".chunk.js";
};